import { render, staticRenderFns } from "./userdata.vue?vue&type=template&id=501698a5&scoped=true&"
import script from "./userdata.vue?vue&type=script&lang=js&"
export * from "./userdata.vue?vue&type=script&lang=js&"
import style0 from "./userdata.vue?vue&type=style&index=0&id=501698a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501698a5",
  null
  
)

export default component.exports